"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var type_guards_1 = require("../../type-guards");
var helpers_1 = require("../../helpers");
function MessageFile(_a) {
    var file = _a.file;
    var fileUrl = (0, type_guards_1.isDatabaseFile)(file) ? file.url : URL.createObjectURL(file);
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, type_guards_1.isDatabaseFile)(file) ? (react_1.default.createElement("button", { className: "message-file btn btn--sm" },
        react_1.default.createElement("a", { className: "black p-0 d-flex gap-1 align-items-center", href: fileUrl },
            react_1.default.createElement("svg", { className: "icon mb-0 flex-shrink-0", width: "20", height: "20" },
                react_1.default.createElement("use", { href: "#download" })),
            (0, helpers_1.getFileNameFromPath)(file.key)))) : (react_1.default.createElement("div", { className: "loader p-2 grid place-center" },
        react_1.default.createElement("svg", { className: "icon mb-0", width: "18", height: "18" },
            react_1.default.createElement("use", { href: "#loader" }))))));
}
exports.default = MessageFile;
